import React from "react";
import { Link } from "react-router-dom";
import MasterLayout from "../masterLayout/MasterLayout";
import { Icon } from "@iconify/react";

const NoPermissionPage = () => {
  return (
    <MasterLayout disableAccessCheck={true}>
      <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "72vh", padding: "20px" }}>
        <div 
          className="card border-0 shadow-lg text-center" 
          style={{ 
            maxWidth: "500px", 
            width: "100%", 
            borderRadius: "16px", 
            overflow: "hidden",
            background: "rgba(255, 255, 255, 0.9)",
            backdropFilter: "blur(10px)"
          }}
        >
          {/* Top accent line */}
          <div style={{ height: "6px", background: "linear-gradient(90deg, #ed1c24 0%, #ff5e62 100%)" }}></div>
          
          <div className="card-body p-40">
            {/* Warning Icon Container */}
            <div className="d-flex justify-content-center mb-24">
              <div 
                className="rounded-circle d-flex justify-content-center align-items-center animate-pulse" 
                style={{ 
                  backgroundColor: "#fff5f5", 
                  width: "90px", 
                  height: "90px",
                  boxShadow: "0 8px 24px rgba(237, 28, 36, 0.15)"
                }}
              >
                <Icon icon="solar:shield-warning-bold-duotone" style={{ color: "#ed1c24", fontSize: "52px" }} />
              </div>
            </div>

            {/* Typography */}
            <h3 className="fw-bold mb-12" style={{ color: "#1a1a1a", letterSpacing: "-0.5px", fontSize: "24px" }}>
              Access Restricted
            </h3>
            <p className="text-secondary-light mb-32 px-1" style={{ fontSize: "15px", lineHeight: "1.6" }}>
              You do not have the required permissions to view this module. If you believe this is an error, please contact your administrator.
            </p>

            {/* Action Buttons */}
            <div className="d-flex flex-column gap-3 justify-content-center align-items-center w-100">
              <Link 
                to="/" 
                className="btn py-12 px-32 radius-8 fw-bold text-white shadow-sm border-0 transition-all hover-scale d-flex align-items-center justify-content-center" 
                style={{ 
                  background: "linear-gradient(135deg, #ed1c24 0%, #d11219 100%)",
                  fontSize: "15px",
                  minWidth: "220px",
                  height: "46px"
                }}
              >
                <Icon icon="solar:home-2-bold" className="me-8" style={{ fontSize: "18px" }} />
                Go to Home Page
              </Link>
              
              {/* <button 
                onClick={() => window.history.back()} 
                className="btn btn-outline-secondary py-12 px-32 radius-8 fw-bold transition-all hover-scale d-flex align-items-center justify-content-center"
                style={{ 
                  fontSize: "15px",
                  minWidth: "220px",
                  height: "46px",
                  border: "1.5px solid #dcdcdc",
                  color: "#4a4a4a",
                  background: "white"
                }}
              >
                <Icon icon="solar:arrow-left-bold" className="me-8" style={{ fontSize: "18px" }} />
                Go Back
              </button> */}
            </div>
          </div>
        </div>
      </div>

      {/* Embedded CSS for animations and hovers */}
      <style>
        {`
          .animate-pulse {
            animation: pulse 2s infinite;
          }
          @keyframes pulse {
            0% {
              transform: scale(1);
              box-shadow: 0 8px 24px rgba(237, 28, 36, 0.15);
            }
            50% {
              transform: scale(1.05);
              box-shadow: 0 8px 30px rgba(237, 28, 36, 0.3);
            }
            100% {
              transform: scale(1);
              box-shadow: 0 8px 24px rgba(237, 28, 36, 0.15);
            }
          }
          .hover-scale {
            transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          }
          .hover-scale:hover {
            transform: translateY(-2px);
            opacity: 0.95;
            box-shadow: 0 4px 12px rgba(0,0,0,0.08) !important;
          }
        `}
      </style>
    </MasterLayout>
  );
};

export default NoPermissionPage;
